export function restaurantCurrencyLabel(currency) {
  if (typeof currency !== 'string' || currency.length !== 3 || !/^[A-Z]{3}$/.test(currency)) {
    throw new Error('Restaurant currency is missing or unsupported.');
  }
  return currency === 'MYR' ? 'RM' : currency;
}
